module.exports = __webpack_public_path__ + "static/media/play.93f175e5.jpg";